import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import { isPage } from "./lib/util"; // このページにだけ適用の記述 ※バリデーション部分参照
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation'; // バリデーション使う時はここのコメントアウト外す

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

// headerロゴ
document.addEventListener('DOMContentLoaded', (event) => {
  window.addEventListener('scroll', () => {
    const logo = document.querySelector('.hd_logo');
    const logoRink = document.querySelector('.hd_logo_link');
    if (window.scrollY > 100) {
      logo.classList.add('scroll_logo');
      logoRink.classList.add('scroll_logo');
    } else {
      logo.classList.remove('scroll_logo');
      logoRink.classList.remove('scroll_logo');
    }
  });
});


// faq 開閉
document.querySelectorAll('.faq-question').forEach(item => {
  item.addEventListener('click', function() {
    const faqItem = this.parentElement;

    if (faqItem.classList.contains('active')) {
      faqItem.classList.remove('active');
    } else {
      document.querySelectorAll('.faq_block').forEach(faq => faq.classList.remove('active'));
      faqItem.classList.add('active');
    }
  });
});


// ハンバーガーメニュー
const hamburger = document.querySelector('.menu-trigger');
const nav = document.querySelector('.h_block');
hamburger.addEventListener('click', function() {
  hamburger.classList.toggle('js-open');
  nav.classList.toggle('js-open');
});


// スムーススクロール
$(function () {
  var headerHight = 120;
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    if ($(window).width() > 1250) {
      var position = position - headerHight;
    }
    $("html, body").animate({ scrollTop: position }, 550, "swing");
    return false;
  });
});





jQuery(function($) {
  $('.news_archive_list p').click(function(){
    if($(this).next('ul').is(':visible')) { // 既に開いている場所なら
      $(this).next('ul').slideUp(300); // 閉じる
      $(this).removeClass('acv_open');
      $(this).children('span').removeClass('acv_open'); //.acv_openを削除
    } else { // 閉じている場所なら
      $('.news_archive_list ul').slideUp(); // 全部閉じる
      $('.news_archive_list').find('span').removeClass('acv_open'); //.acv_open全削除
      $('.news_archive_list').find('p').removeClass('acv_open');
      $(this).next('ul').slideDown(300); // 開く
      $(this).children('span').addClass('acv_open'); //.acv_open付加
      $(this).addClass('acv_open');
    }
  });
});

// バリデーション呼び出し
$(function() {
  if (isPage('contact')) {
    topValidation();
  }
});


/***********************************************************************
   * SAMPLE
   ***********************************************************************/
const selector = '.sample';
gsap.utils.toArray(selector)?.forEach((item) => {
  gsap.from(item, {
    autoAlpha: 1,
    x: 0,
    y: 0,
    scale: 0,
    rotation: 0,
    skew: 0,
    transformOrigin: 'center center',
    duration: 1, // アニメーションの時間

    scrollTrigger: {
      trigger: item, // 対象の要素を指定
      // scrub: 0.5 // アニメーションをスクロールに同期させる
      start: 'top 80%', // アニメーションの開始位置
      // end: 'top 50%', // アニメーションの終わり位置（ scrub が有効の時のみ有効 ）
      toggleActions: 'play none none reverse', // アニメーションの発火設定
      once: false, // アニメーションを一度きりにする
      markers: true, // デバッグ用マーカー表示
      onEnter: ({ progress, direction, isActive }) => {
        // アニメーションの開始時に処理を追加
        item.classList.add('is-active');
      },
      onLeaveBack: ({ progress, direction, isActive }) => {
        // アニメーションの開始位置に戻った時に処理を追加
        item.classList.remove('is-active');
      },
    },
  });
});
